import React from 'react'
import './Projects.css'

import { projects, Project } from './projects';
import Vignette from './Vignette/Vignette';
import PlayerModal from './PlayerModal/PlayerModal';

function Projects() {
  const [playingProjectIndex, setPlayingProjectIndex] = React.useState<number | null>(null);
  const onClick = (projectIndex: number) => {
    setPlayingProjectIndex(projectIndex);
  }

  const onModalClickClose = () => {
    setPlayingProjectIndex(null);
  }

  const onModalClickPrev = () => {
    if (playingProjectIndex !== null && playingProjectIndex > 0) {
      setPlayingProjectIndex(playingProjectIndex - 1);
    }
  }

  const onModalClickNext = () => {
    if (playingProjectIndex !== null && playingProjectIndex < projects.length - 1) {
      setPlayingProjectIndex(playingProjectIndex + 1);
    }
  }



  return (
    <div className='projects'>
        <h1>VALENTIN
          <br/>
        BRUHIERE</h1>
      <div className="subtitle">
        <h3>Montage Vidéo</h3>
        <h3>Paris</h3>
      </div>
      <div className="vignettes-container">
        {projects.map((project, index) => (
          <Vignette onClick={() => onClick(index)} key={index} project={project} />
        ))}
      </div>
      {playingProjectIndex !== null &&
        <PlayerModal hasNext={playingProjectIndex < projects.length - 1} onClickNext={onModalClickNext} hasPrev={playingProjectIndex > 0} onClickPrev={onModalClickPrev} onClickClose={onModalClickClose} videoUrl={projects[playingProjectIndex].videoUrl} />
      }
    </div>
  )
}

export default Projects
